// Local file paths instead of CDN URLs
export const SPLIDE_SCRIPT_SRC = "/static/scripts/dynamic-devlink/splide.min.js";
export const SPLIDE_CSS_HREF = "/static/scripts/dynamic-devlink/splide-core.min.css";
// Splide class names
export const SPLIDE_TRACK_CLASS_NAME = "splide__track";
export const SPLIDE_LIST_CLASS_NAME = "splide__list";
export const SPLIDE_SLIDE_CLASS_NAME = "splide__slide";
export const SPLIDE_ARROWS_CLASS_NAME = "splide__arrows";
export const SPLIDE_ARROW_CLASS_NAME = "splide__arrow";
export const SPLIDE_ARROW_PREV_CLASS_NAME = "splide__arrow--prev";
export const SPLIDE_ARROW_NEXT_CLASS_NAME = "splide__arrow--next";
export const SPLIDE_ACTIVE_CLASS_NAME = "is-active";
export const SPLIDE_ACTIVE_CLASS_NAME_CSS_MODULE = "is-active__";
// Splide selectors
export const SPLIDE_TRACK_ELEMENT_SELECTOR = '[data-splide-element="track"]';
export const SPLIDE_LIST_ELEMENT_SELECTOR = '[data-splide-element="list"]';
export const SPLIDE_SLIDE_CLASS_SELECTOR = '[data-splide-element="slide"]';
export const SPLIDE_ARROWS_ELEMENT_SELECTOR = '[data-splide-element="arrows"]';
export const SPLIDE_ARROW_ELEMENT_SELECTOR = '[data-splide-element="arrow"]';
// Custom classes
export const CUSTOM_ARROW_PREV = "custom-arrow-prev";
export const CUSTOM_ARROW_NEXT = "custom-arrow-next";
// Type and role selectors
export const SPLIDE_TYPE_SELECTOR = '[data-splide-type]';
export const SPLIDE_TYPE_ATTRIBUTE = 'data-splide-type';
export const SPLIDE_ROLE_NAV = '[data-splide-role="nav"]';
export const SPLIDE_ROLE_CONTENT = '[data-splide-role="content"]';
export const SPLIDE_ARROW_TYPE_ATTRIBUTE = "data-splide-arrow-type";
export const SPLIDE_DATA_FOCUS_ATTRIBUTE = "data-focus";
// Component names
export const SPLIDE_COMPONENT_NAME_ATTRIBUTE = "data-splide-component-name";
